module.exports = __webpack_public_path__ + "img/home_cell_line_1.2bea7e41.png";